import { render, staticRenderFns } from "./VTag.vue?vue&type=template&id=b1e43d9c&"
import script from "./VTag.vue?vue&type=script&lang=ts&"
export * from "./VTag.vue?vue&type=script&lang=ts&"
import style0 from "./VTag.vue?vue&type=style&index=0&id=b1e43d9c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports